import { useQuery } from "@tanstack/react-query";
import verificationService from "..";

const useGetVerification = ({ isAdmin }: { isAdmin?: boolean }) =>
  useQuery({
    queryKey: ["getVerificationResult"],
    queryFn: () => verificationService.getVerificationResult(),
    select: (res) => res,
    enabled: isAdmin,
  });

export { useGetVerification };
